import { createMediaSchema, htmlStringHasText } from 'utils/sharedSchema.utils.js';
import * as Yup from 'yup';

const verifiedPaymentsBlockSchema = Yup.object().shape({
  headline: Yup.string().label('Headline').required().default(''),
  description: Yup.string().label('Text').default('').test(htmlStringHasText),
  image: createMediaSchema('Please add an image'),
});

export default verifiedPaymentsBlockSchema;
